import React from "react";
import { useTranslation } from "react-i18next";
import LogoTag from "../../atoms/logo";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div
      style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
    >
      <div 
        style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginLeft: '1rem', marginRight: '1rem' }}
      >
          <LogoTag width="120"></LogoTag>
          <p style={{ fontSize: '0.85rem', color: '#fff' }}>{t("footer.support")}</p>
          <p style={{ fontSize: '0.85rem', color: '#fff' }}>{t("footer.copyright")}</p>

      </div>
    </div>
  );
};

export default Footer;
